/* components/versioning/SnapshotView.jsx — read-only просмотр снимка версии.
   Диспетчер по kind: CardSnapshotView (сырьё) / TTKSnapshotView (ТТК, из TTKViewBlocks) /
   MenuSnapshotView (меню; блюда с badge «удалено»). Шапка «Версия N · дата · автор»,
   кнопки «Вернуться к текущей» и «Восстановить эту версию».
   ХЕНДОФФ → frontend/src/components/versioning/SnapshotView.jsx. */

import { KbjuTable, TTKSnapshotView } from '../ttk/TTKViewBlocks.jsx';
import { FoodCostBadge } from '../ui/Badge.jsx';
import { Button } from '../ui/Button.jsx';
import { Icon } from '../ui/Icon.jsx';
import { fmt } from '../../lib/format.js';

  const g1 = (v) => (v == null || isNaN(v) ? '—' : new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(v));

  function CardSnapshotView({ s }) {
    return (
      <div className="snap-card">
        <div className="snap-card__head">
          <h4 className="t-h4">{s.name}</h4>
          <span className="t-caption text-dim">{s.category}{s.default_unit ? ' · учёт в ' + (s.default_unit === 'шт' ? 'штуках' : 'граммах') : ''}</span>
        </div>
        <div className="snap-card__kbju">
          <h5 className="ttk-sub-title t-caption">КБЖУ на 100 г</h5>
          <KbjuTable per_100g={{ kcal: s.kcal_per_100g, protein: s.protein_per_100g, fat: s.fat_per_100g, carbs: s.carbs_per_100g }} />
        </div>
        <div className="snap-card__row">
          <span className="snap-card__key t-caption">Аллергены</span>
          <span className="snap-card__val">{(s.allergens && s.allergens.length) ? s.allergens.join(', ') : '—'}</span>
        </div>
        {s.current_price && (
          <div className="snap-card__row">
            <span className="snap-card__key t-caption">Цена закупки</span>
            <span className="snap-card__val num">{fmt.money(s.current_price.amount_rub)}/{s.current_price.unit}{s.current_price.supplier_name ? ' · ' + s.current_price.supplier_name : ''}</span>
          </div>
        )}
        {s.notes && (
          <div className="snap-card__row">
            <span className="snap-card__key t-caption">Заметки</span>
            <span className="snap-card__val">{s.notes}</span>
          </div>
        )}
      </div>
    );
  }

  function MenuSnapshotView({ s }) {
    const bySection = {};
    (s.dishes || []).forEach((d) => { (bySection[d.section] = bySection[d.section] || []).push(d); });
    const sections = (s.sections && s.sections.length) ? s.sections.map((x) => x.title) : Object.keys(bySection);
    return (
      <div className="snap-menu">
        <div className="snap-menu__head">
          <h4 className="t-h4">{s.name}</h4>
        </div>
        <div className="snap-menu__metrics">
          <div className="snap-metric"><span className="t-caption text-dim">Блюд</span><span className="num">{(s.dishes || []).filter((d) => !d._deleted).length}</span></div>
          <div className="snap-metric"><span className="t-caption text-dim">Средний чек</span><span className="num">{fmt.money(s.average_check)}</span></div>
          <div className="snap-metric"><span className="t-caption text-dim">Целевой FC</span><span className="num">{fmt.percent(s.target_food_cost_pct, { digits: 0 })}</span></div>
        </div>
        {sections.map((sec) => (
          <section key={sec} className="snap-menu__sec">
            <h5 className="ttk-sub-title t-caption">{sec}</h5>
            <ul className="snap-menu__dishes">
              {(bySection[sec] || []).map((d, i) => (
                <li key={i} className={'snap-menu__dish' + (d._deleted ? ' is-deleted' : '')}>
                  <span className="grow truncate">{d.title}
                    {d._deleted && <span className="badge badge--bad badge--sm">удалено</span>}
                  </span>
                  {d.food_cost_pct != null && <FoodCostBadge value={d.food_cost_pct} size="sm" />}
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    );
  }

  function SnapshotView({ kind, version, onReturn, onRestore, busy }) {
    if (!version) return null;
    const s = version.snapshot || {};
    let body = null;
    if (kind === 'card') body = <CardSnapshotView s={s} />;
    else if (kind === 'ttk') body = <TTKSnapshotView snapshot={s} />;
    else if (kind === 'menu') body = <MenuSnapshotView s={s} />;

    return (
      <div className="snapshot-view">
        <div className="snapshot-view__bar">
          <div className="snapshot-view__meta">
            <Icon name="clock" size={16} />
            <span className="snapshot-view__ver num">Версия {version.version_number}</span>
            <span className="t-caption text-dim">{fmt.date(version.created_at)} · {version.author_email}</span>
          </div>
          <div className="snapshot-view__act">
            <Button variant="ghost" size="sm" iconLeft="arrow-left" onClick={onReturn}>К текущей</Button>
            <Button variant="secondary" size="sm" iconLeft="refresh" loading={busy} onClick={onRestore}>Восстановить</Button>
          </div>
        </div>
        {version.summary && <p className="snapshot-view__summary t-body-sm text-dim">{version.summary}</p>}
        <div className="snapshot-view__body">{body}</div>
      </div>
    );
  }

export { SnapshotView };
export { CardSnapshotView };
export { MenuSnapshotView };
